/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Empty_Dates_TitleInputs */

const en_tl_empty_dates_title = /** @type {(inputs: Tl_Empty_Dates_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing has dates yet`)
};

const de_tl_empty_dates_title = /** @type {(inputs: Tl_Empty_Dates_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Termine`)
};

/**
* | output |
* | --- |
* | "Nothing has dates yet" |
*
* @param {Tl_Empty_Dates_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_empty_dates_title = /** @type {((inputs?: Tl_Empty_Dates_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Empty_Dates_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_empty_dates_title(inputs)
	return en_tl_empty_dates_title(inputs)
});